module.exports = __webpack_public_path__ + "static/media/address.5cfcbc13.png";